import { IBasket } from '@/interfaces/IBasket/IBasket';
import { IProduct } from '@/interfaces/IProduct/IProduct';
import { IOrder } from '@/interfaces/IOrder/IOrder';

declare global {
  interface Window {
    // eslint-disable-next-line no-unused-vars
    eS(sendEvent: string, action: string, data: { [name: string]: unknown }): undefined;
  }
}

interface IThankProduct extends IProduct {
  count?: number | string;
}

interface ISputnikProduct {
  productKey: string;
  price: string;
  isInStock: number;
  currency: string;
  quantity?: string;
}

const getId = (product: IThankProduct) => product?.offer?.id || product?.id;

class ESputnik {
  #formatItem(product: IThankProduct): ISputnikProduct {
    const EProduct: ISputnikProduct = {
      productKey: getId(product).toString(),
      price: product.price?.price?.toString(),
      isInStock: +product.isAvailable,
      currency: 'UAH',
    };

    if (product.count) {
      EProduct.quantity = product.count.toString();
    }

    return EProduct;
  }

  #formatItems(items: Array<IThankProduct>): Array<ISputnikProduct> {
    if (!items) return [];
    return items.map(this.#formatItem);
  }

  productPage(product: IThankProduct) {
    if (product && window.eS) {
      window.eS('sendEvent', 'ProductPage', {
        ProductPage: this.#formatItem(product),
      });
    }
  }

  statusCart(basketData: IBasket) {
    if (basketData) {
      window.eS('sendEvent', 'StatusCart', {
        StatusCart: this.#formatItems(basketData.items),
        GUID: basketData.guid,
      });
    }
  }

  categoryPage(key: string) {
    if (key) {
      window.eS('sendEvent', 'CategoryPage', {
        CategoryPage: {
          categoryKey: key,
        },
      });
    }
  }

  purchasedItems(items: Array<IThankProduct>, orderData: IOrder) {
    window.eS('sendEvent', 'PurchasedItems', {
      OrderNumber: orderData.id,
      PurchasedItems: this.#formatItems(items),
      GUID: orderData.guid,
    });
  }

  // eslint-disable-next-line camelcase
  customerData(customerData: { user_phone: string; user_name?: string; user_email: string }) {
    window.eS('sendEvent', 'CustomerData', {
      CustomerData: customerData,
      //   {
      //   externalCustomerId: '1234509876',
      //   user_email: 'example@email.com',
      //   user_name: 'Johny',
      //   user_card_id: '321',
      //   user_phone: '3801111111111',
      //   user_city: 'Gdańsk',
      //   user_tags_gender: 'male',
      // },
    });
  }

  searchRequest(query: string) {
    window.eS('sendEvent', 'SearchRequest', {
      SearchRequest: {
        search: query,
        isFound: 0,
      },
    });
  }

  addToWishlist(product: IProduct) {
    window.eS('sendEvent', 'AddToWishlist', {
      AddToWishlist: this.#formatItem(product),
    });
  }
}

export default new ESputnik();
